import {
  MaterialReactTable,
  type MRT_TableOptions,
  useMaterialReactTable,
} from "material-react-table";
import {
  createStoryListColumns,
  type StoryListHandlers,
} from "Components/Stories/Management/storyListColumns";
import type { StoryListItemDto } from "Infrastructure/Api/Api";
import { useMemo } from "react";
import { useResource } from "Translations/Resources";
import { useTableLocalization } from "Utils/TableLocalizationUtils";

type Props = StoryListHandlers & {
  data: Array<StoryListItemDto>;
  isLoading: boolean;
  isRefetching: boolean;
  rowCount?: number;
  tableProps?: Partial<MRT_TableOptions<StoryListItemDto>>;
};

/** The Admin list: server-paged, sortable and filterable across all authors. */
export const StoryListTable = ({
  data,
  isLoading,
  isRefetching,
  rowCount,
  tableProps,
  isPending,
  onPreview,
  onPublish,
  onUnpublish,
  onDelete,
}: Props) => {
  const { t } = useResource();
  const localization = useTableLocalization();
  const columns = useMemo(
    () =>
      createStoryListColumns(t, {
        isPending,
        onPreview,
        onPublish,
        onUnpublish,
        onDelete,
      }),
    [t, isPending, onPreview, onPublish, onUnpublish, onDelete],
  );
  const table = useMaterialReactTable({
    ...tableProps,
    data,
    columns,
    rowCount,
    localization,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      ...tableProps?.initialState,
      density: "compact",
    },
    state: {
      ...tableProps?.state,
      isLoading,
      showProgressBars: isRefetching,
    },
    muiTablePaperProps: {
      sx: { borderRadius: "10px" },
    },
  });

  return <MaterialReactTable table={table} />;
};
